import { MedrecruitLogo } from '#/shared/components/MedrecruitLogo';
import { appConfig } from '#/shared/config/AppConfig';

export function Header() {
  return (
    <header className="flex items-center justify-between p-md bg-surface-l0">
      <MedrecruitLogo medrecruitWebBaseUrl={appConfig.medrecruitWebBaseUrl} />
    </header>
  );
}
